import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {trashOutline, trashSharp} from "ionicons/icons"


import {useUsers} from "../../../contexts/UserContext"
import User       from "../../../types/User"

interface componentProps {
    item: User
    setSelectedLockingSystemPermissions: React.Dispatch<React.SetStateAction<number[]>>;
}

const ButtonDeleteAll: React.FC<componentProps> = ({item, setSelectedLockingSystemPermissions} ) => {

    const { t } = useTranslation()
    const [presentAlert] = useIonAlert();

    const { deleteAllLockingSystemPermissions } = useUsers()

    const alertDeleteAll = (ev: any) => {
        return presentAlert({
            header:  t('userLockingSystemPermissions.alerts.delete_all.header'),
            message: t('userLockingSystemPermissions.alerts.delete_all.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel',
            }, {
                text: t('common.continue'),
                role: 'confirm',
                handler: () => { onDeleteAll() },
            },]
        })
    }

    const onDeleteAll = async () => {
        await deleteAllLockingSystemPermissions(item)
        setSelectedLockingSystemPermissions([])
    }

    return (
        <IonButton color="danger" fill="clear" onClick={(ev) => alertDeleteAll(ev)}
                   size="small" type="button">
            <IonIcon slot="start" ios={trashOutline} md={trashSharp} />
            {t('common.remove_all_permissions')}
        </IonButton>
    )

}

export default ButtonDeleteAll